import createService from './createService';
const url = process.env.REACT_APP_BACKEND_ENDPOINT || 'http://localhost:1337';
export const emperor = createService({
  url
});
